import { Msg } from './../../auth/model/user.model';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NodesService } from '../service/nodes.service';
import { MsgModel } from '../../common-components/msg/model/msg.model';
import { Node } from 'src/app/component/node/model/node.model';

@Component({
    selector: 'app-node-item',
    templateUrl: './node-item.component.html',
    styleUrl: './node-item.component.scss'
})
export class NodeItemComponent implements OnInit {
    nodeId: number;
    node: Node;

    isLoading: boolean = false;
    msg: MsgModel;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private nodesService: NodesService
    ) {}

    ngOnInit(): void {
        this.isLoading = true;

        const nodeId = this.route.snapshot.paramMap.get('nodeId');

        if (nodeId) {
            this.nodeId = +nodeId;
            this.getNode();
        }
    }

    getNode() {
        this.nodesService.show(this.nodeId).subscribe({
            next: (res) => {
                console.warn(res.node);
                if (res.node) {
                    this.node = res.node;
                    this.goTo(this.node);
                } else if (res.msg) {
                    this.msg = res.msg;
                } else {
                    this.msg = new MsgModel();
                    this.msg.SUCCESS = false;
                    this.msg.MSG = 'There was no Node found.';
                }
            },
            error: (err) => {
                if (err.msg) {
                    this.msg = err.msg;
                } else {
                    this.msg = { MSG: 'Failed to retrieve Node.', SUCCESS: false };
                }

                this.isLoading = false;
            },
            complete: () => {
                this.isLoading = false;
            }
        });
    }

    goTo(node: Node) {
        if (node.NODE_ACCOUNT_REQUESTS[0]) {
            this.router.navigateByUrl(`/account-request/edit/${node.ID}`, { replaceUrl: true });
        } else if (node.NODE_COES[0]) {
            // COE
            if (node.WORKFLOW_NODES?.[0]?.WORKFLOW?.WORKFLOW_NODE_TYPES?.NAME == 'COE') {
                this.router.navigateByUrl(`/coe-2010/view/${node.NODE_COES[0].CO.ID}`, { replaceUrl: true });
            }

            // COE-2017
            else if (node.WORKFLOW_NODES?.[0]?.WORKFLOW?.WORKFLOW_NODE_TYPES?.NAME == 'COE-2017') {
                this.router.navigateByUrl(`/coe-2017/view/${node.NODE_COES[0].CO.ID}`, { replaceUrl: true });
            }

            // COE-2024
            else if (
                node.WORKFLOW_NODES?.[0]?.WORKFLOW?.WORKFLOW_NODE_TYPES?.NAME == 'COE-2023 Workflow' ||
                node.WORKFLOW_NODES?.[0]?.WORKFLOW?.WORKFLOW_NODE_TYPES?.NAME == 'COE-2024 Workflow'
            ) {
                if (node.NODE_COES?.[0]?.CO?.COE_SURVEYS?.[0]?.SURVEY_ID === 2) {
                    switch (node.WORKFLOW_STATE_TYPES.NAME) {
                        case 'Creation State':
                            this.router.navigateByUrl(`/coe/ecoe/view/${node.NODE_COES[0].CO.ID}/${node.ID}`, { replaceUrl: true });
                            break;
                        case 'Recruiter Fix State':
                            this.router.navigateByUrl(`/coe/ecoe/view/${node.NODE_COES[0].CO.ID}/${node.ID}`, { replaceUrl: true });
                            break;
                        case 'Approved State':
                        case 'Denied State':
                        case 'Completion State':
                        case 'Void State':
                            this.router.navigateByUrl(`/coe/ecoe/view/${node.NODE_COES[0].CO.ID}/${node.ID}`, { replaceUrl: true });
                            break;
                        case 'Review State':
                        case 'Second Reviewer State':
                        case 'Self Review State':
                            this.router.navigateByUrl(`/coe/ecoe/review/view/${node.NODE_COES[0].CO.ID}/${node.ID}`, { replaceUrl: true });
                            break;
                        default:
                            this.msg = { MSG: 'Unable to determine node to redirect to.', SUCCESS: false };
                            break;
                    }
                } else if (node.NODE_COES?.[0]?.CO.COE_SURVEYS?.[0]?.SURVEY_ID === 7) {
                    switch (node.WORKFLOW_STATE_TYPES.NAME) {
                        case 'Creation State':
                            this.router.navigateByUrl(`/coe/papercoe/view/${node.NODE_COES[0].CO.ID}/${node.ID}`, { replaceUrl: true });
                            break;
                        case 'Recruiter Fix State':
                            this.router.navigateByUrl(`/coe/papercoe/view/${node.NODE_COES[0].CO.ID}/${node.ID}`, { replaceUrl: true });
                            break;
                        case 'Approved State':
                        case 'Denied State':
                        case 'Completion State':
                        case 'Void State':
                            this.router.navigateByUrl(`/coe/papercoe/view/${node.NODE_COES[0].CO.ID}/${node.ID}`, { replaceUrl: true });
                            break;
                        case 'Review State':
                        case 'Second Reviewer State':
                        case 'Self Review State':
                            this.router.navigateByUrl(`/coe/papercoe/review/view/${node.NODE_COES[0].CO.ID}/${node.ID}`, { replaceUrl: true });
                            break;
                        default:
                            this.msg = { MSG: 'Unable to determine node to redirect to.', SUCCESS: false };
                            break;
                    }
                } else {
                    this.msg = { MSG: 'Unable to determine node to redirect to.', SUCCESS: false };
                }
            } else {
                this.msg = { MSG: 'Unable to determine node to redirect to.', SUCCESS: false };
            }
        } else {
            this.msg = { MSG: 'Unable to determine node to redirect to.', SUCCESS: false };
        }
    }
}
